import styled from 'styled-components'
export const DateWrapper = styled.div`
    width : 100% ;
    .ant-picker{
        width : 100% ;
    }
`